<template>
  <button class="btn" :class="[enabled? '' : 'disabled', styleType]" type="button" :disabled="!enabled" @click="onClicked">
    {{ buttonText }}
  </button>
</template>

<script>
export default {
  name: "v-button",
  props: [
    'buttonText',
    'enabled',
    'styleType'
  ],
  methods: {
    onClicked()
    {
      this.$emit("clicked");
    }
  },
  computed: {
    /*
    getStyle () {
      let style = '';
      switch (this.styleType) {
        case 'button-orange':
          style = 'button-orange';
          break;
        default:
          style = '';
          break;
      }
      return style;
    }
     */
  }
}
</script>

<style lang="scss" scoped>
button
{
  background-color: $primary-blue;
  color: $font-light;
  box-shadow: $default-shadow;


  width: 100%;
  height: 50px;

  font-size: 1.25rem;
  border-radius: 5px;

  &.disabled
  {
    opacity: 1;
    background-color: $medium-highlight;

    &:hover
    {
      color: white;
    }
  }

  &.impulse
  {
    background-color: $activity-pink;
    color: $font-light;
  }

  &.more
  {
    background-color: $activity-orange;
    color: $font-light;
  }

  &.smart
  {
    background-color: $activity-blue;
    color: $font-light;
  }

  &.together
  {
    background-color: $activity-green;
    color: $font-light;
  }
}

.button-orange
{
  background-color: $activity-orange;
}
</style>